"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeletons = void 0;
var react_1 = __importDefault(require("react"));
var Skeletons = function (_a) {
    var height = _a.height;
    var skeletonStyle = {
        backgroundColor: 'var(--bui_color_background, #000)',
        width: '100%',
        height: '20px',
        borderRadius: '4px',
        opacity: 0.15,
        animation: 'pulse 1s infinite ease-in-out',
        marginBottom: '15px',
    };
    var numberOfSkeltonBars = Math.floor(height / 35);
    var skeletonBars = Array.from({ length: numberOfSkeltonBars }, function (_, i) { return (react_1.default.createElement("div", { key: i, style: skeletonStyle })); });
    return react_1.default.createElement(react_1.default.Fragment, null, skeletonBars);
};
exports.Skeletons = Skeletons;
